import React, { useRef, useEffect } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { isTrue, num, formatNum } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const CGU_ERROR = 'Vous devez accepter les conditions de vente et d\'annulation.';
const {
  app
} = window;
export default function SubmitBooking({
  ...props
}) {
  const state = BookingFormStore.useState(s => s);
  const id = BookingFormStore.useState(s => s.submit_form_id);
  const _ref_submit = useRef();
  useEffect(function (e) {
    // empêche l'envoi du formulaire si autre chose que l'id de soumission change
    if (!id || _ref_submit.current === id) return;
    _ref_submit.current = id;
    if (isTrue(state.b2b)) return;
    if (state.submitting) return;
    if (state.oauth_register && !state.cgu_accepted) {
      return BookingFormStore.update(function (store) {
        store.error = CGU_ERROR;
      });
    }
    e?.persist?.();
    BookingFormStore.update(function (store) {
      store.submitting = true;
    });
    const user_session = app.state.session?.user;
    const create_account = state.oauth_register || isTrue(state.create_account);
    const user = {
      login: state['user[login]'],
      lastname: state['user[lastname]'],
      firstname: state['user[firstname]'],
      phone_number: state['user[phone_number]'] || '',
      password: state['user[password]'] || undefined,
      id: create_account ? '' : user_session?.id || ''
    };
    if (isTrue(state.continue_as_guest)) {
      delete user.password;
      user.id = '';
    }
    const booking = {
      date: state.date,
      number_of_people: state.people,
      start_hour: state.start,
      end_hour: state.end,
      space_id: props.space?.id,
      disposition: state.disposition,
      amount: state.amount,
      services: state.services
    };
    (async function () {
      try {
        var response = await ajaxRequest(action('CreateBooking'), {
          data: {
            user: user,
            booking: booking,
            create_account: create_account,
            cgu_accepted: isTrue(state.cgu_accepted),
            oauth_register: isTrue(state.oauth_register),
            source: props['white-label-booking'] === true ? 'direct' : 'classic',
            discount_code_id: window.localStorage.getItem('booking_discount_code_id'),
            discount_code: state.discount_code
          }
        });
      } catch (update) {
        BookingFormStore.update(function (store) {
          Object.keys(update).forEach(field => store[field] = update[field]);
          store.submitting = false;
        });
        return;
      }
      window.localStorage.setItem('current_booking_price', response.price);
      window.localStorage.setItem('current_booking_id', response.id);
      const add_newsletter = [isTrue(state.newsletter_subscription) && !state.in_newsletter, isTrue(response.oauth_newsletter)].some(condition => condition);
      if (add_newsletter) {
        BookingFormStore.update(function (store) {
          store.loading = true;
        });
        try {
          await ajaxRequest(action('addUserToNewsletter'), {
            data: {
              email: state['user[login]']
            }
          });
        } catch (e) {
          console.error(e);
        }
        BookingFormStore.update(function (store) {
          store.loading = false;
        });
      }
      if (isTrue(response.needs_session_refresh)) {
        try {
          const session = await ajaxRequest('/get-session');
          app.state.session = session || undefined;
          app.state.session.fetched = true;
        } catch (e) {
          console.error(e);
        }
      }
      const grand_total = num(response.price);
      const is__free = grand_total > 0 === false;
      emitTCEvent();
      if (is__free) {
        BookingFormStore.update(function (store) {
          store.redirecting = true;
          store.submitting = false;
        });
        return window.setTimeout(function () {
          app.navigateTo(URL('LibConfirmationPage'));
        }, 1000);
      }
      BookingFormStore.update(function (store) {
        store.grand_total = grand_total;
        store.submitting = false;
        store.info = response.info;
        store.error = undefined;
        store.warning = undefined;
        store.step = 2;
        store.booking_id = response.id;
        store.status_messages = {};
      });
      props.stepChange?.(2);
      window.scrollTo(0, 0);
      function emitTCEvent() {
        app.emit({
          event: 'TC_Click',
          source: 'BookingComponent',
          data: {
            e: e,
            action: 'reservation_espace'
          }
        });
        let total_without_services = num(grand_total);
        (state.services || []).forEach(function (service) {
          total_without_services = num(total_without_services - num(service.total_price));
        });
        app.emit({
          event: 'TC_TunnelEvent',
          source: 'BookingComponent.validate',
          data: {
            template: 'paiement',
            page: 'paiement',
            type: props.space?.type === 'b_seminar' ? 'seminaire' : 'coworking',
            city: props.space?._etablishment?.address?.city,
            date: props.date,
            etablishment: props.space?._etablishment?.name,
            space: props.space?.name,
            people: props.people,
            booking: state.start && state.end ? state.start + 'h-' + state.end + 'h' : state.start === 'afternoon' ? 'Demi-journée - Après midi' : state.start === 'morning' ? 'Demi-journée - Matin' : state.start === 'day' ? 'Journée' : '',
            services: (state.services || []).map(service => service.service_info?.title || '').join(' ').trim(),
            price: formatNum(grand_total, '0.00'),
            price_with_services: formatNum(total_without_services, '0.00')
          }
        });
      }
    })();
  }, [id, state, props.space]);
  return null;
}
